export default function MonthView({ weeks, onSelectDate }) {
  return (
    <div className="bg-white border border-[#E2E8F0] rounded-lg overflow-hidden" data-testid="schedule-month-view">
      <div className="grid grid-cols-7 text-xs font-semibold text-[#4B5563] uppercase border-b border-[#E2E8F0]">
        {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((d) => (
          <div key={d} className="px-2 py-2 text-center">{d}</div>
        ))}
      </div>
      {weeks.map((week, wi) => (
        <div key={wi} className="grid grid-cols-7 border-b border-[#E2E8F0] last:border-b-0">
          {week.map((d) => (
            <div
              key={d.date}
              data-testid={`month-day-${d.date}`}
              onClick={() => onSelectDate(d.date)}
              className={`h-20 border-r border-[#E2E8F0] last:border-r-0 p-1.5 cursor-pointer hover:bg-[#F7FEE7] transition-colors duration-200 ${d.inMonth ? "" : "bg-[#F8F9FA] text-[#94A3B8]"}`}
            >
              <p className="text-xs">{d.dayNum}</p>
              {d.count > 0 && <span className="mt-1 inline-block text-[10px] bg-[#76C121]/15 text-[#00823B] rounded-full px-1.5 font-medium">{d.count}</span>}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
